<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <div class="m-portlet__head">
        <div class="m-portlet__head-progress">
          <!-- here can place a progress bar-->
        </div>
        <div class="m-portlet__head-wrapper">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">轮转表管理 | 新增轮转信息</h3>
            </div>
          </div>
          <div class="m-portlet__head-tools">
            <el-button @click="Back()">返回</el-button>
          </div>
        </div>
      </div>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <!--begin: Form Body -->
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">住培生姓名：</label>
            <div class="col-xl-2" style="padding-top: 8px;">
              <span>{{form.cpstuname}}</span>
            </div>
            <label class="col-xl-2 col-form-label">住培生工号：</label>
            <div class="col-xl-2" style="padding-top: 8px;">
              <span>{{form.cpstuno}}</span>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">管理单元：</label>
            <div class="col-xl-2">
              <el-form-item prop="secretarysec" :rules="{required: true, message: '管理单元不能为空', trigger: 'blur'}">
                <el-select v-model="form.secretarysec" filterable placeholder="请选择" @change="ManageSecChange">
                  <el-option label="请选择" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label">轮转科室：</label>
            <div class="col-xl-2">
              <el-form-item prop="cpsec" :rules="{required: true, message: '轮转科室不能为空', trigger: 'blur'}">
                <el-select v-model="form.cpsec" filterable placeholder="请选择">
                  <el-option label="请选择" value=""></el-option>
                  <el-option v-for="item in secOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">计划开始时间：</label>
            <div class="col-xl-2">
              <el-form-item prop="cpbegindate" :rules="{required: true, message: '计划开始时间不能为空', trigger: 'blur'}">
                <el-date-picker v-model="form.cpbegindate" type="date" placeholder="计划开始时间" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label">计划结束时间：</label>
            <div class="col-xl-2">
              <el-form-item prop="cpenddate" :rules="{required: true, message: '计划结束时间不能为空', trigger: 'blur'}">
                <el-date-picker v-model="form.cpenddate" type="date" placeholder="计划结束时间" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12 m--align-center">
                  <el-button type="success" icon="el-icon-s-order" @click="Save" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PlanAdd',
    data() {
      return {
        form: {
          cpstuid: '',
          cpstuname: '',
          cpstuno: '',
          cpsec: '',
          cpbegindate: '',
          cpenddate: '',
          cpstatus: 1,
          token: '',
          secretarysec:''
        },
        username: '',
        rolelevel: '',
        tecOptions: null,
        fullscreenLoading: false,
        secOptions: [],
        managesecOptions: []
      }
    },
    methods: {
      Save: function() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.fullscreenLoading = true
            this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/Add', this.form)
              .then(res => {
                console.log(res.data)
                if (res.data.Code === 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                  console.log('保存成功')
                  this.$router.push({
                    name: 'PlanList',
                    params: {
                      id: this.form.cpstuid,
                      name: this.form.cpstuname
                    }
                  })
                } else {
                  this.$message({
                    message: res.data.Msg,
                    type: 'error'
                  })
                }
                this.fullscreenLoading = false
              })
              .catch(err => {
                console.log(err)
                this.$message({
                  message: '保存失败',
                  type: 'error'
                })
                this.fullscreenLoading = false
              })
          } else {
            console.log('error submit!!')
            return false;
          }
        })
      },
      Back: function() {
        this.$router.push({
          name: 'PlanList',
          params: {
            id: this.form.cpstuid,
            name: this.form.cpstuname
          }
        })
      },
      LoadManageSec: function() {
        var args = {
          token: this.form.token,
          username: this.username,
          rolelevel: this.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      },
      ManageSecChange: function() {
        this.form.leavesec = ''
        this.secOptions = []
        this.loadsec()
      },
      loadsec: function() {
        var args = {
          token: this.form.token,
          username: this.username,
          rolelevel: this.rolelevel,
          mamagesec: this.form.secretarysec
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
          that.secOptions = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.username = sessionStorage.getItem('username')
      this.rolelevel = sessionStorage.getItem('rolelevel')
      this.form.cpstuid = this.$route.params.cpstuid
      this.form.cpstuname = this.$route.params.name
      // 获取数据字典信息
      var args = {
        id: this.form.cpstuid,
        token: this.form.token
      }
      this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIStu/Info', args, function(data, model) {
        model.cpstuno = data.Data.StuNo
      }, null, null, this.form)
      this.LoadManageSec()
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }

  .el-select {
    width: 100%;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
</style>
